import { render } from "./App.vue?vue&type=template&id=215e4302&lang=pug"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=215e4302&lang=stylus"

import exportComponent from "/home/jenkins/agent/workspace/front_prod/world-cup-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__